import React from 'react'
import { useNavigate } from 'react-router-dom'
import { BigWishlist, GredientArw, Location } from '../../../assests/ExportImageIcon'
import WishlistCard from './wishlistCard'

const Collaboration = ({ items = [], loading = false }) => {
    const navigate = useNavigate()

    return (
        <>
            <div className='mb-4'>
                <div className='wishlistItinerary'>
                    <span className='wishlistItinerary__icon'><img src={Location} alt="" /></span>
                    <div className='wishlistItinerary__text'>
                        <div className='wishlistItinerary__title'>Plan Your Perfect Trip</div>
                        <div className='wishlistItinerary__desc'>Organize your saved items into a complete trip itinerary with timelines, budgets, and collaborators</div>
                    </div>
                    <button type='button' className='wishlistItinerary__btn' onClick={() => navigate('/create-wishlist')}>
                        Create New Trip <img src={GredientArw} alt="" />
                    </button>
                </div>
            </div>

            {loading ? (
                <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                    <p className='fare-extra-hint'>Loading your collaborations...</p>
                </div>
            ) : !items.length ? (
                <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                    <div className='wishlistEmptyState'>
                        <span className='wishlistEmptyState__icon'>
                            <img src={BigWishlist} alt="" width="80" height="80" />
                        </span>
                        <div className='wishlistEmptyState__title'>No collaborations yet</div>
                    </div>
                </div>
            ) : (
                <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                    <div className='selectItemsCount'>
                        <span className='selectItemsCount__label'>{items.length} {items.length === 1 ? 'Collaboration' : 'Collaborations'} found</span>
                    </div>

                    <div className='wishlistPage__list'>
                        {items.map((item) => (
                            <WishlistCard key={item.id} wishlist={item} onOpen={() => navigate(`/wishlist-detail?id=${item.id}`)} />
                        ))}
                    </div>
                </div>
            )}
        </>
    )
}

export default Collaboration
